import { joinURL } from 'ufo';
import type { Property } from '~/core/entities/property';
import { PropertyFiltersPresenter } from './PropertyFiltersPresenter';
import type { BreadcrumbItem } from '~/components/ui/breadcrumb';
import type { Overwrite } from '~~/type-utils';

type PropertyBreadcrumb = Overwrite<
	BreadcrumbItem,
	{
		structuredDataLabel?: string;
		route: string;
	}
>;

export class PropertyPresenter {
	static getBreadcrumItems(property: Property): PropertyBreadcrumb[] {
		const { region, state, city, commercialId } = property;

		return [
			{ label: 'Início', structuredDataLabel: 'PilarHomes', route: '/' },
			{
				label: `${city} - ${state}`,
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: [state],
					cities: [city]
				})
			},
			{
				label: region,
				route: PropertyFiltersPresenter.getPathFromFilters({
					states: [state],
					cities: [city],
					regions: [region]
				})
			},
			{
				label: commercialId,
				structuredDataLabel: `Imóvel ${commercialId}`,
				route: `/imovel/${commercialId}/${property.slug}`
			}
		];
	}

	static getPropertyPageUrl(property: Property, websiteUrl: string): string {
		return joinURL(websiteUrl, '/imovel', property.commercialId, property.slug);
	}
}
